import {
	NavigateOptions,
	SetURLSearchParams,
	URLSearchParamsInit,
	useLocation,
	useSearchParams,
} from 'react-router-dom';

export const useSearchParamsWithHash = (): [URLSearchParams, SetURLSearchParams] => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { hash } = useLocation();

	return [
		searchParams,
		(
			nextInit?: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
			navigateOpts?: NavigateOptions,
		) => {
			setSearchParams(nextInit, navigateOpts);
			if (hash) {
				const url = new URL(document.URL);
				url.hash = hash;
				document.location.href = url.href;
			}
		},
	];
};
